import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Career from "./pages/Career";
import Institution from "./pages/Institution";
import ProjeDetay from "./pages/ProjeDetay"; // en üste eklemeyi unutma


 
function App() {
  return (
    <div className="App"> 
       <Header /> 
          <Routes> 
            <Route path="/" element={<Home />}></Route>
            <Route path="/hakkimizda" element={<About />}></Route>
              <Route path="/cozumlerimiz/:slug" element={<ProjeDetay />} />
              <Route path="/iletisim" element={<Contact />}></Route>
            <Route path="/kariyer" element={<Career />}></Route>
            <Route path="/kurumlar" element={<Institution />}></Route>
          </Routes> 
        <Footer /> 

    </div>
  );
}

export default App;
